import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import "toastr/build/toastr.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from './pages/login/login';
import ForgotPassword from './pages/login/ForgotPassword';
import ChangePassword from './pages/login/ChangePassword';
import ConfirmChangePassword from './pages/login/ConfirmChangePassword';
import Geo from './pages/geo/geo';
import ListReports from './pages/reports/listReports';
import UpdatePassword from './pages/login/updatePassword';
import Landing from './pages/login/landing';
import ReportDetails from './pages/reports/reportDetails';
import ESGDashboard from './pages/dashboardEsg/dashboard';
import toastr from "toastr";


function App(params) {

  toastr.options.positionClass = "toast-top-center";

  return (
    <div className='container-fluid'>
      <BrowserRouter>
        <Routes>
          <Route path="/" Component={Login}></Route>
          <Route path="/login" Component={Login}></Route>
          <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
          <Route path="/changepassword" element={<ChangePassword />}></Route>
          <Route path="/confirmchangepassword" element={<ConfirmChangePassword />}></Route>
          <Route path="/updatepassword" element={<UpdatePassword />}></Route>
          <Route path="/geo" element={<Geo />}></Route>
          <Route path="/score" element={<ListReports />}></Route>
          <Route path="/report" element={<ReportDetails />}></Route>
          <Route path="/dashboard-riscos" element={<ESGDashboard />}></Route>
          <Route path="/landing" element={<Landing />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;


